<template>
  <main>
    <div class="container">
      <!-- Кнопка для меня(очищает корзину в localStorage) -->
      <!-- <p @click="clear">clear</p> -->

      <!-- Это когда-то были touch события -->
      <!-- <div class="main-wrapper product-card" 
        v-touch:moving="swipeHandler"
        v-touch:start="startHandler"
        v-touch:end="endHandler"
        :style="{'opacity': opacity}"
        ref="wrapper"
        > -->




      <div class="main-wrapper product-card" 
        :style="{'opacity': opacity}"
        ref="wrapper"
        >
        <!-- Content header start -->
        <div class="product-info">
          <!-- Если много фотографий включается модальный слайдер -->
          <b-link
            v-if="dataLoaded && productInfo.photo.length != 0"
            v-b-modal.modalSlider
            class="product-info__img"
            v-bind:style="{
              backgroundImage: 'url(' + productInfo.previewPicture + ')',
            }"
          >
          </b-link>
          <!-- Если фотографий меньше, просто блок с картинкой -->
          <div
            v-else
            class="product-info__img"
            v-bind:style="{
              backgroundImage: 'url(' + productInfo.previewPicture + ')',
            }"
          ></div>

          <!-- Информация о товаре в хэдэре start -->
          <div class="product-info__list">
            <h1 class="product-info__title">{{ productInfo.name }}</h1>
            <b-link v-b-modal.modalPassport class="product-info__link">паспорт модели</b-link>

            <div class="product-options" v-if="dataLoaded && productInfo.prop.typeOfMount">
              <div class="option">
                <p class="option__title">Крепление:</p>
                <p class="option__text" v-for="(item, index) in productInfo.prop.typeOfMount" :key="index">{{ item }}</p>
              </div>
            </div>

            <div class="product-info__price" v-if="dataLoaded">
              <span>от </span>
              <span class="num">{{ productInfo.price.value }}</span>
              <span>{{ productInfo.price.valuta }} / {{ productInfo.price.measure }}</span>
            </div>
          </div>
          <!-- Информация о товаре в хэдэре end -->
        </div>
        <!-- Content header end -->

        <!-- Content main start -->
        <div class="order-block">
          <h2 class="grey-title">Бланк заказа</h2>
          <div class="order-form" :class="{blur: $localStorageGet('viewCollection')}">
            <!-- Блок с размерами start -->
            <div class="size-block" v-if="dataLoaded && productInfo.formated.sizeList.length != 0">
              <p class="size-block__title">Размер <span>(mm):</span></p>
              <div class="size-block__items">
                <span
                  v-for="(sizeItem, sizeIndex) in productInfo.formated.sizeList"
                  :key="sizeIndex"
                  :class="{
                    active: currentSize == sizeItem.value ? true : false,
                  }"
                  @click="setSize(sizeItem.value)"
                  >{{ sizeItem.title }}</span
                >
              </div>
            </div>
            <!-- Блок с размерами end -->
            <!-- Блок с ориентациями start -->
            <div class="size-block" v-if="dataLoaded && productInfo.formated.orientationList.length != 0">
              <p class="size-block__title">Ориентация:</p>
              <div class="size-block__items">
                <span
                  v-for="(orientationItem, orientationIndex) in productInfo.formated.orientationList"
                  :key="orientationIndex"
                  :class="{ active: currentOrientation == orientationItem.value ? true : false}"
                  @click="setOrientation(orientationItem.value)"
                  >{{ orientationItem.title }}</span
                >
              </div>
            </div>
            <!-- Блок с ориентациями end -->
            <!-- Блок с цветами start -->
            <ColorsBlock 
              v-if="colorList.length != 0"
              :colorList="colorList"
              :element="element"
            ></ColorsBlock>
            <!-- Блок с цветами end -->
            <!-- Блок с оснастками start -->
            <ForInstallationBlock
              v-if="forInstallationList.length != 0"
              :element="element"
              :forInstallationList="forInstallationList"
            ></ForInstallationBlock>
            
            <!-- Блок с оснастками end -->
            <!-- Оценка start -->
            <FeedbackBlock
              :element="element"
              :productInfo="productInfo"
            ></FeedbackBlock>
            <!-- Оценка end -->
          </div>
        </div>
        
      <!-- Content main end -->
      </div>
      <!-- nav start -->
        <Navigation
          :collection="collection"
          :element="element"
          :productInfo="productInfo"
          :clickLeft="clickLeft"
          :clickRight="clickRight"
          :indexProductInCollection="indexProductInCollection"
          @firstProduct="isFirst($event)"
          @lastProduct="isLast($event)"
        ></Navigation>
        <!-- nav end -->
    </div>

    <ModalSlider v-if="dataLoaded" :product="productInfo"></ModalSlider>
    <ModalPassport v-if="dataLoaded" :product="productInfo"></ModalPassport>
  </main>
</template>
<script>
import ModalSlider from "@/components/modal/modalSlider";
import ModalPassport from "@/components/modal/ModalPassport";
import Navigation from "@/components/navigation/pagination";
import ColorsBlock from "@/components/productCard/colorsBlock";
import ForInstallationBlock from "@/components/productCard/forInstallationBlock";
import FeedbackBlock from "@/components/productCard/feedbackBlock";

export default {
  props: ["collection", "element"],
  components: { ModalSlider, ModalPassport, Navigation, ColorsBlock, ForInstallationBlock, FeedbackBlock },
  data: () => ({
    productInfo: {}, //Полнаяя информация о текущем товаре
    colorList: [], //Список доступных цветов
    forInstallationList: [], //Список доступных оснасток
    dataLoaded: false, //условие для вывода опций в карточке, без него тоже всё работает но кровавая консоль
    currentSize: 0,
    currentOrientation: 0,
    feedback: {
      rating: '',
      comment: ''
    },
    touchStartPosition: 0,
    clickRight: false, 
    clickLeft: false,
    opacity: 1,
    isFirstProduct: true,
    isLastProduct: false,
    indexProductInCollection: 0
  }),
  methods: {
    clear(){
      this.$localStorageSet('miniCart', {}) 
    },
    // При загрузке страницы вытягиваем информацию о текущем товаре(по productID и collectionID)
    setCurrentProduct() {
      return this.$store
        .dispatch("GET_CURRENT_PRODUCT", {
          collectionID: this.collection,
          productID: this.element,
        })
        .then((r) => {
          this.productInfo = r;
        })
        .then((r) => (this.dataLoaded = true)); //Данные полностью загружены
    },
    init() {
      // установка первого размера как текущего
      if (Object.keys(this.productInfo.formated.sizeList).length > 0) {
        this.setSize(Object.keys(this.productInfo.formated.sizeList)[0]);
      }else{
        this.getColorList();
      }
      // установка первого значения ориентации как текущего
      if (Object.keys(this.productInfo.formated.orientationList).length > 0) {
        this.setOrientation(Object.keys(this.productInfo.formated.orientationList)[0]);
      }
      // Получить список оснасток
      this.getForInstallationList();

      

        // Определить индекс элемента(в магазине нет номеров у товара:(  ))
        let collectionProducts = this.$localStorageGet('currentCollection'); //Информация о текущей коллекции
        this.indexProductInCollection = collectionProducts.products.findIndex( el => el.id == this.element); //Индекс текущего товара в объекта товаров коллекции
    },

    // Установить актуальный размер
    setSize(value) {
      this.currentSize = value.replace("enum_id_", "");
      this.getColorList(); //Обновить цвета
    },
    setOrientation(value){
      this.currentOrientation = value.replace("enum_id_", "");
      this.getColorList(); //Обновить цвета
    },
    // Обновить цвета в зависимости от размера/ориентации
    getColorList() {
      let arr = [];
      if (this.productInfo.hasOwnProperty("offers")) {

        let isSize, isOrientation = false;
        let el = this.productInfo.offers[Object.keys(this.productInfo.offers)[0]];

        // Проверка есть ли размер и ориентация в товаре
        el.prop.orientation.value != null ? isOrientation = true : isOrientation = false;
        el.prop.size.value != null ? isSize = true : isSize = false;

        
        for (let i = 0; i < Object.keys(this.productInfo.offers).length; i++) {
          let offer = this.productInfo.offers[Object.keys(this.productInfo.offers)[i]];
          let colorItem = this.getColorItem(offer);  //Тот же "offer", но в более приятном виде
         
          if(isSize && isOrientation){  //Если есть размер и ориентация
            if(colorItem.orientationValue == this.currentOrientation && colorItem.colorSize == this.currentSize){
              arr.push(colorItem)
            }
          }

          if(isSize && !isOrientation){ //Если есть только размер
            this.currentOrientation = 0;
            if(colorItem.colorSize == this.currentSize){
              arr.push(colorItem)
            }
          }

          if(!isSize && isOrientation){ //Если есть только ориентации
            this.currentSize = 0;
            if(colorItem.orientationValue == this.currentOrientation){
              arr.push(colorItem)
            }
          }

          if(!isSize && !isOrientation){ //Если нет ни размера ни ориентации
            this.currentSize = 0;
            this.currentOrientation = 0;
            arr.push(colorItem)
          }

        }
      }
      let miniCart = this.$localStorageGet('miniCart');  //Миникорзина из localStorage
      if(Object.keys(miniCart).length != 0 && miniCart['productId_' + this.element] !=  undefined){ //Если в миникорзине что-то есть и это текущий товар
        miniCart['productId_' + this.element].forEach(element => { 
          let optionItem = arr.find(x => x.colorID == element.colorID); //Найти в корзине уже когда-то выбранные цвета
          if(optionItem) optionItem.quantity = element.quantity; //подставить уже когда-то выбранное количество
        });
      }
      this.colorList = arr;
    },
    // Собираем инфу о цвете в кучу
    getColorItem(offer){
      let colorItem = {};
      colorItem.number = this.productInfo.number;
      colorItem.photo = this.productInfo.previewPicture;
      colorItem.orientationTitle = offer.prop.orientation.title;
      colorItem.orientationValue = offer.prop.orientation.value;
      colorItem.colorID = offer.id;
      colorItem.productID = this.element;
      colorItem.collectionID = this.collection;
      colorItem.productName = this.productInfo.name;
      colorItem.offerName = offer.name;
      colorItem.offerID = offer.id;
      colorItem.typeProduct = 'sku';
      colorItem.colorName = offer.prop.color.title;
      colorItem.colorValue = offer.prop.color.value;
      colorItem.colorSize = offer.prop.size.value;
      colorItem.colorSizeName = offer.prop.size.title;
      colorItem.colorHex = offer.prop.color.hex ? offer.prop.color.hex : '#000';  //Если не указан цвет, то по-умолчанию черный
      this.$set(colorItem, "quantity", 0);  //Добавил поле количество и сделал его реактивным
      return colorItem;
    },
    getInstallationItem(offer){
      let installationItem = {};
      installationItem.number = this.productInfo.number;
      installationItem.productID = this.element;
      installationItem.collectionID = this.collection;
      installationItem.photo = this.productInfo.previewPicture;
      installationItem.productName = this.productInfo.name;
      installationItem.offerName = offer.name;
      installationItem.installationID = offer.id;
      installationItem.offerID = offer.id;
      installationItem.typeProduct = 'install';
      installationItem.name = offer.name;
      this.$set(installationItem, "quantity", 0);  //Добавил поле количество и сделал его реактивным
      return installationItem;
    },

    getForInstallationList(){
      let arr = [];
      if(Object.keys(this.productInfo.prop.forInstallation).length > 0){
        for(let i = 0; i < Object.keys(this.productInfo.prop.forInstallation).length; i++){
          let offer = this.productInfo.prop.forInstallation[Object.keys(this.productInfo.prop.forInstallation)[i]];
          let installationItem = this.getInstallationItem(offer);
          arr.push(installationItem);
        }

        let miniCart = this.$localStorageGet('miniCart');  //Миникорзина из localStorage
        if(Object.keys(miniCart).length != 0 && miniCart['productId_' + this.element] !=  undefined){ //Если в миникорзине что-то есть и это текущий товар
          miniCart['productId_' + this.element].forEach(element => { 
            let optionItem = arr.find(x => x.installationID == element.installationID); //Найти в корзине уже когда-то выбранные цвета
            if(optionItem) optionItem.quantity = element.quantity; //подставить уже когда-то выбранное количество
          });
        }
        this.forInstallationList = arr;
      }else{
        this.forInstallationList = [];
        return false
      }

    },
    swipeHandler(e){

      if(e.targetTouches[0].screenX < this.touchStartPosition && !this.isLastProduct){
        
        let el = this.$refs.wrapper;
        el.style.right = (this.touchStartPosition - e.targetTouches[0].screenX) + 'px';

        if(Math.abs(this.touchStartPosition - e.targetTouches[0].screenX) >= 150){
            this.opacity = 1 - (0.005 * Math.abs(this.touchStartPosition - e.targetTouches[0].screenX)) + 0.3
          
        }

        if(Math.abs(this.touchStartPosition - e.targetTouches[0].screenX) >= 200){
          this.clickRight = true;
          el.style.right = 0;
          this.opacity = 1;
        }
      }else if(e.targetTouches[0].screenX > this.touchStartPosition && !this.isFirstProduct){
        let el = this.$refs.wrapper;
        el.style.right = (this.touchStartPosition - e.targetTouches[0].screenX) + 'px';
        if(Math.abs(this.touchStartPosition - e.targetTouches[0].screenX) >= 150){
            this.opacity = 1 - (0.005 * Math.abs(this.touchStartPosition - e.targetTouches[0].screenX)) + 0.3
            
        }
        if(Math.abs(this.touchStartPosition - e.targetTouches[0].screenX) >= 200){
          this.clickLeft = true;
          el.style.right = 0;
          this.opacity = 1;
          
        }
      }
    },
    startHandler(e){
      this.touchStartPosition = e.targetTouches[0].screenX;
    },
    endHandler(){
      let el = this.$refs.wrapper;
      this.touchStartPosition = 0
      el.style.right = 0
      this.clickRight = false;
      this.clickLeft = false;
      this.opacity = 1;
    }, 
    isFirst(e){
      this.isFirstProduct = e;
    },
    isLast(e){
      this.isLastProduct = e;
    }
  },
  created() {
    this.setCurrentProduct().then((r) => {
      this.init();
    });
  },
  watch: {
    '$route'(){
      this.setCurrentProduct().then((r) => {
        this.init();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
  .container{
    overflow: hidden;
  }
</style>

